import axios from 'axios';

const url = `${process.env.GATSBY_TWILL_URL}/api/logout`;

export async function logout() {
  return axios.post(url);
}
